export interface LoginConfig {
  secret: string;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoginConfig: LoginConfig = {
  secret: 'appbar2021appbar',
};
